import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getDefaultLanguage, getSupportedLanguageCodes, getEnabledLanguages, getLanguageByCode } from './config/languages';

import en from './locales/en.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';

// Build resources object dynamically from enabled languages
const buildResources = () => {
  const resources = {};
  const enabledLanguages = getEnabledLanguages();

  enabledLanguages.forEach(lang => {
    switch (lang.code) {
      case 'en':
        resources.en = { translation: en };
        break;
      case 'ar':
        resources.ar = { translation: ar };
        break;
      case 'fr':
        resources.fr = { translation: fr };
        break;
      default:
        break;
    }
  });

  return resources;
};

const defaultLang = getDefaultLanguage();
const supportedLngs = getSupportedLanguageCodes();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: buildResources(),
    fallbackLng: defaultLang,
    supportedLngs: supportedLngs,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export const changeLanguage = (lng) => {
  const lang = getLanguageByCode(lng);
  if (!lang || !lang.enabled) {
    console.warn(`Language ${lng} is not enabled`);
    return;
  }

  i18n.changeLanguage(lng);
  document.documentElement.lang = lng;
  document.documentElement.dir = lang.dir || 'ltr';
  localStorage.setItem('i18nextLng', lng);
};

const savedLng = localStorage.getItem('i18nextLng') || defaultLang;
const savedLangConfig = getLanguageByCode(savedLng);
const initialLang = savedLangConfig && savedLangConfig.enabled ? savedLng : defaultLang;
const initialLangConfig = getLanguageByCode(initialLang);

document.documentElement.lang = initialLang;
document.documentElement.dir = initialLangConfig.dir || 'ltr';

export default i18n;
